module.exports = __webpack_public_path__ + "img/yes-match-g2.f228705c.png";